import { render, staticRenderFns } from "./AdminBoard.vue?vue&type=template&id=4c1da60c&scoped=true&"
import script from "./AdminBoard.vue?vue&type=script&lang=ts&"
export * from "./AdminBoard.vue?vue&type=script&lang=ts&"
import style0 from "./AdminBoard.vue?vue&type=style&index=0&id=4c1da60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1da60c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VMenu,VSimpleTable,VTextField})
